import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Nav } from 'app/components/LeftNav';
import { NavTitle } from 'app/components/LeftNav/NavTitle.jsx';
export default function NavNotifications(props) {
    const { match } = props;
    return (_jsxs(Nav, { children: [_jsx(NavTitle, { label: "All Notifications", icon: "fas-bell", to: `${match.url}/all` }), _jsx(NavTitle, { permissions: ['notifications___read'], label: "Manage subscriptions", to: `${match.url}/manage`, icon: "fas-cog" })] }));
}
